import CustomSearchBar from "components/CustomSearchBar";
import { Col, Row, Button } from "reactstrap";
import { useEffect, useState } from "react";
import Pagination from "@mui/material/Pagination";
import { DataGrid } from "@mui/x-data-grid";
import { toast } from "react-toastify";
import "react-loading-skeleton/dist/skeleton.css";
import { useAssignPolicyDetailsMutation } from "features/CrmDashboardComp/CmrApiSlice";
import {
  useGetAssignPolicyQuery,
  useGetCrmInsuranceLeadsQuery,
} from "features/Insurance/InsuranceApiSlice";
import { Tag } from "antd";
import Swal from "sweetalert2";
import {
  TextField,
  MenuItem,
  Box,
  Divider,
  CircularProgress,
} from "@mui/material";
import {
  useGetDistrictByStateQuery,
  useGetStatesQuery,
} from "services/locationApiSlice";
import Select from "react-select";

const InsuranceVerification = ({ refetch, handleCloseAssignEmployeeModal }) => {
  const [pagination, setPagination] = useState({
    page: 1,
    pageCount: 0,
    perPage: 50,
  });
  const [searchKeyStatus, setSearchKeyStatus] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState("");
  const [stateId, setStateId] = useState("");
  const [districtId, setDistrictId] = useState("");
  const [stateName, setStateName] = useState("");
  const [districtName, setDistrictName] = useState("");
  const [stateList, setStateList] = useState([]);
  const [districtList, setDistrictList] = useState([]);
  const {
    data: getStates,
    isLoading: loadingStateOptions,
  } = useGetStatesQuery();
  const {
    data: dataDistrict,
    isLoading: loadingDistrictOptions,
  } = useGetDistrictByStateQuery(stateId);
  const [policyStatus, setPolicyStatus] = useState("Assigned For Inspection");
  const [remarks, setRemarks] = useState("");
  const [policyDetails, setPolicyDetails] = useState({
    policy_id: "",
    policy_url: "",
    file: null,
  });
  //   const status = "Inspection Completed";

  //   const { data, refetch: refetchLeads } = useGetAssignPolicyQuery({
  //     pagination,
  //     searchKeyStatus: debouncedSearch ? debouncedSearch : "",
  //     status,
  //   });
  const queryParameters = {
        page:pagination.page,

      perPage: pagination.perPage,
    searchKey: debouncedSearch,
    selectedProduct: "Cattle",
    stateCode: stateId,
    districtCode: districtId,
    blockCode: "",
    // statusName: "Inspection Completed",
    // statusName:RoleAcessParams.groups.includes("INSURER")?"KYC Verified":""
  };
  const {
    data,
    refetch: refetchLeads,
    isLoading
  } = useGetCrmInsuranceLeadsQuery(queryParameters);
  const [assignLeads] = useAssignPolicyDetailsMutation();
  const [leadList, setLeadList] = useState([]);
  const [filterIdAgain, setFilterIdAgain] = useState([]);
  const customStyles = {
    control: (provided) => ({
      ...provided,
      minHeight: "40px",
      height: "40px",
      padding: "0px",
      fontSize: "12px",
    }),
  };
  useEffect(() => {
    if (getStates != undefined) {
      setStateList(getStates?.data?.results);
    }
  }, [getStates]);

  const columns = [
    { field: "full_name", headerName: "Name", width: 180 },
    { field: "phone_number", headerName: "Phone Number", width: 160 },
    { field: "lead_source", headerName: "Lead Source", width: 180 },

    {
      field: "current_status",
      headerName: "Application Status",
      width: 220,
      renderCell: (cellValues) => {
        const status = cellValues.row.current_status;

        const statusConfig = {
          "Lead Details Modified": {
            color: "blue",
          },
          Assigned: { color: "gold" },
          "Can Not Process": { color: "error" },
          "Lead Generated": { color: "volcano" },
        };

        const { color, icon } = statusConfig[status] || {
          color: "geekblue",
        };

        return (
          <Tag
            bordered={false}
            color={color}
            style={{
              display: "flex",
              alignItems: "center",
              gap: "8px",
              padding: "3px 9px",
              fontSize: "13px",
              fontWeight: "500",
              borderRadius: "6px",
            }}
          >
            {icon}
            <span>{status}</span>
          </Tag>
        );
      },
    },
    { field: "state_name", headerName: "State", width: 150 },
  ];
  const CustomPagination = () => {
    return (
      <Pagination
        color="primary"
        count={pagination?.pageCount}
        page={pagination?.page}
        onChange={(event, value) => {
          setPagination({
            page: value,
            pageCount: pagination?.pageCount,
            perPage: pagination.perPage,
          });
        }}
        variant="outlined"
        shape="rounded"
      />
    );
  };
  const filterDataBasedId = (item) => {
    setFilterIdAgain(item);
  };
  useEffect(() => {
    if (data) {
      setLeadList(data?.data?.results || []);
      setPagination({
        page: data?.data?.current_page || 1,
        pageCount: data?.data?.pages || 0,
        perPage: data?.data?.per_page || 50,
      });
    }
  }, [data]);

  const handleAssign = (e) => {
    e.preventDefault();

    if (filterIdAgain?.length === 0) {
      Swal.fire({
        title: "Select Leads",
        text: "Please select Leads for Policy",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Continue",
        cancelButtonText: "Cancel",
        confirmButtonIcon: "fas fa-arrow-right",
      });
      return;
    }
    let payload = new FormData();
    payload.append("lead_id_list", JSON.stringify(filterIdAgain));
    payload.append("current_remarks", remarks);
    payload.append("current_status", policyStatus);

    assignLeads(payload)
      .unwrap()
      .then(() => {
        toast.success("Verified Successfully!");
        setRemarks("");
        setPolicyDetails({ policy_id: "", policy_url: "", file: null });
        refetchLeads();
        refetch();
        handleCloseAssignEmployeeModal();
      })
      .catch(() =>
        toast.error("Error while Verifying Leads. Try again later!")
      );
  };
  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearch(searchKeyStatus.trim() ? searchKeyStatus : "");
    }, 500);

    return () => clearTimeout(handler);
  }, [searchKeyStatus]);
  const handleStateOptions = () => {
    let responseAgentArray = [];
    stateList.map((state) => {
      responseAgentArray.push({
        value: state.state_code,
        label: state.state_name,
        ConditionName: "state",
      });
    });
    return responseAgentArray;
  };
  const handleDistrictOptions = () => {
    let responseAgentArray = [];
    districtList.map((district) => {
      responseAgentArray.push({
        value: district.district_code,
        label: district.district_name,
        ConditionName: "district",
      });
    });
    return responseAgentArray;
  };
  const onLocationChange = (event) => {
    if (event.ConditionName == "state") {
      setDistrictId("");
      setStateId(event.value);
      setStateName(event.label);
    }
    if (event.ConditionName == "district") {
      setDistrictId(event.value);
      setPagination({ page: 1, pageCount: 0, perPage: 50 });
      setDistrictName(event.label);
    }
  };

  useEffect(() => {
    if (dataDistrict != undefined) {
      setDistrictList(dataDistrict?.data?.results);
    }
  }, [dataDistrict]);
  return (
    <div className="p-3">
      <Row>
        <Col lg="6">
          <TextField
            select
            size="small"
            label="Select Status"
            value={policyStatus}
            onChange={(e) => setPolicyStatus(e.target.value)}
          >
            <MenuItem value="Assigned For Inspection">
              {" "}
              Assigned For Inspection
            </MenuItem>

            <MenuItem value="Initiate Payment">Initiate Payment</MenuItem>
          </TextField>
        </Col>
      </Row>
      <form onSubmit={handleAssign}>
        <Row className="mt-3">
          <Col lg="6">
            <TextField
              type="text"
              fullWidth
              label="Remarks"
              value={remarks}
              onChange={(e) => setRemarks(e.target.value)}
              required
              size="small"
            />
          </Col>
          <Col md="2" className="mx-4">
            <Button
              id="AddLeads"
              className="buttonGreenDefaultColor"
              size="sm"
              type="submit"
            >
              Submit &nbsp;
              <i className="mdi mdi-account-arrow-right custom-btn-fs fs-6"></i>
            </Button>
          </Col>
        </Row>
      </form>

      <div className="row mt-2 p-1">
        <Col md="2" className="mt-4">
          <CustomSearchBar sendSearchFunction={setSearchKeyStatus} />
        </Col>
        <Col md="2" className="mb-2 position-relative">
          <Select
            menuPlacement="auto"
            options={handleStateOptions()}
            placeholder={stateId === "" ? "State" : stateName}
            value={stateId === "" ? null : { value: stateId, label: stateName }}
            onChange={onLocationChange}
            styles={customStyles}
            isLoading={loadingStateOptions}
            className="mt-4"
          />
          {stateId && (
            <span
              className="clear-icon"
              onClick={() => {
                setStateId("");
                setStateName("");
              }}
              style={{
                position: "absolute",
                top: "76%",
                right: "60px",
                transform: "translateY(-50%)",
                cursor: "pointer",
                color: "gray",
                fontSize: "12px",
                zIndex: 1000,
              }}
            >
              ✕
            </span>
          )}
        </Col>
        <Col md="2" className="mb-2 position-relative">
          <Select
            menuPlacement="auto"
            options={handleDistrictOptions()}
            placeholder={districtName === "" ? "District" : districtName}
            value={
              districtName === ""
                ? null
                : { value: districtId, label: districtName }
            }
            onChange={onLocationChange}
            styles={customStyles}
            isLoading={loadingDistrictOptions}
            className="mt-4"
          />
          {districtName && (
            <span
              className="clear-icon"
              onClick={() => {
                setDistrictId("");
                setDistrictName("");
              }}
              style={{
                position: "absolute",
                top: "76%",
                right: "60px",
                transform: "translateY(-50%)",
                cursor: "pointer",
                color: "gray",
                fontSize: "12px",
                zIndex: 1000,
              }}
            >
              ✕
            </span>
          )}
        </Col>
      </div>
      <Box sx={{ width: "100%", mt: 2 }}>
        <DataGrid
          rows={leadList}
          columns={columns}
          loading={isLoading }
          checkboxSelection
          autoHeight
          onRowSelectionModelChange={(item) => filterDataBasedId(item)}
          components={{
            Pagination: CustomPagination,
          }}
          slots={{
            pagination: CustomPagination,
            loadingOverlay: () => (
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  height: "100px",
                }}
              >
                <CircularProgress size={32} />
              </Box>
            ),
          }}
        />
      </Box>
    </div>
  );
};

export default InsuranceVerification;
